import { createActions } from 'redux-actions';

export const { showCloseClaimModal, openClaim } = createActions(
  {
    showCloseClaimModal: () => undefined,
    openClaim: message => message,
  }
);
